"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var prismic = _interopRequireWildcard(require("@prismicio/client"));

var _react2 = require("@prismicio/react");

var prismicH = _interopRequireWildcard(require("@prismicio/helpers"));

var _defaultConfig = _interopRequireDefault(require("./defaultConfig"));

var _CustomReactMarkdown = _interopRequireDefault(require("./shared/components/MarkdownRenderers/CustomReactMarkdown"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

/* eslint-disable class-methods-use-this */
var PrismicClient = /*#__PURE__*/function () {
  function PrismicClient(setComponentState, restEndpoint) {
    _classCallCheck(this, PrismicClient);

    this.setComponentState = setComponentState;
    this.client = prismic.createClient(restEndpoint || _defaultConfig["default"].restEndpoint);
  } // TODO:
  // - Build in pagination re-fetching


  _createClass(PrismicClient, [{
    key: "fetchData",
    value: function fetchData(query, normalizer, errorHandler) {
      var _this = this;

      return this.client.query(query).then(function (response) {
        var formattedData = normalizer(response.results);

        _this.setComponentState(formattedData);
      })["catch"](function (error) {
        if (errorHandler instanceof Function) {
          return errorHandler(error, false);
        } // TODO: Introduce improved handling of error responses when no handle is present
        // eslint-disable-next-line no-console


        console.warn('Prismic failed to return content. Error response received.');
        return error;
      });
    } // Renders only the plain text, should be used in most cases
    // Preferred means of rendering

  }, {
    key: "renderText",
    value: function renderText(text) {
      return prismicH.asText(text);
    } // Renders only the plain text, should be used in most cases
    // Preferred means of rendering

  }, {
    key: "textToMarkdown",
    value: function textToMarkdown(text) {
      // TODO apply reactMarkdown to renderFullmarkup and serializeHTML
      // noWrapper flag causes the markdown to be rendered
      // inside a react fragment and not in a p and div tag.
      // this should not be used to render large bodies of formatted text--
      // use renderFullMarkup for that
      return /*#__PURE__*/_react["default"].createElement(_CustomReactMarkdown["default"], {
        source: prismicH.asText(text),
        noWrapper: true
      });
    } // Renders all the elements configured in Prismic
    // Should be used for all body elements/consider using serializeHTML for more rendering options
    // TODO:
    // - Customize benefitsHtmlSerializer for maximum usable cases

  }, {
    key: "renderFullMarkup",
    value: function renderFullMarkup(text) {
      return /*#__PURE__*/_react["default"].createElement(_react2.PrismicRichText, {
        field: text
      });
    }
  }]);

  return PrismicClient;
}();

var _default = PrismicClient;
exports["default"] = _default;